import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasFieldSchema = withDefaults({
  type: 'tas-field',
  objectExtensions: ['tas-field'],
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'values',
    },
    {
      kind: 'attribute',
      name: 'label',
    },
    {
      kind: 'attribute',
      name: 'fieldType',
    },
    {
      kind: 'attribute',
      name: 'dataType',
    },
    {
      kind: 'attribute',
      name: 'required',
    },
    {
      kind: 'attribute',
      name: 'visible',
    },
    {
      kind: 'attribute',
      name: 'options',
    },
    {
      kind: 'attribute',
      name: 'validations',
    },
    {
      kind: 'attribute',
      name: 'helpText',
    },
    {
      kind: 'attribute',
      name: 'placeholder',
    },
    {
      kind: 'attribute',
      name: 'sortOrder',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'flavor',
    },
    {
      kind: 'attribute',
      name: 'ordinal',
    },
    {
      kind: 'attribute',
      name: 'province',
    },
    {
      kind: 'belongsTo',
      name: 'tasApplication',
      type: 'tas-application',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'tasProgramInstance',
      type: 'tas-program-instance',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'tasCourse',
      type: 'tas-course',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default TasFieldSchema;
